import React from "react";
import { useHistory } from "react-router";
import { Link, useLocation } from "react-router-dom";
import Box from "@material-ui/core/Box";
import People from "@material-ui/icons/People";
import List from "@material-ui/icons/List";
import DescriptionIcon from "@material-ui/icons/Description";
import BusinessIcon from "@material-ui/icons/Business";
import LanguageIcon from "@material-ui/icons/Language";
import GroupIcon from '@material-ui/icons/Group';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import SettingsIcon from '@material-ui/icons/Settings';

const SuperadminSidebar = () => {
  const history = useHistory();
  let location = useLocation();
  const url = location.pathname.split("/")[1];
  function logout() {
    localStorage.clear("token");
    history.push("/");
  }

  return (
    <div
      className="sidebar"
      data-color="purple"
      data-background-color="white"
      data-image="../assets/img/sidebar-1.jpg"
    >
      <div className="logo">
        <img
          src={process.env.PUBLIC_URL + "/logo.png"}
          alt="Logo"
          className="logo"
          style={{ height: "100px" }}
        />
      </div>
      <div className="sidebar-wrapper">
        <ul className="nav">
          <li
            className={
              url === "superadmin-dashboard" ? "nav-item active" : "nav-item"
            }
          >
            <Link to="/superadmin-dashboard" className="nav-link navbar-toggler" aria-controls="navigation-index" aria-expanded="false">
              <Box fontSize={16} fontWeight="fontWeightRegular" className="d-flex align-items-center">
                <i className="material-icons">dashboard</i>Dashboard
              </Box>
            </Link>
          </li>
          <li className={url === "superadmin-users" ? "nav-item active" : "nav-item"}>
            <Link to="/superadmin-users" className="nav-link navbar-toggler" aria-controls="navigation-index" aria-expanded="false">
              <Box fontSize={16} fontWeight="fontWeightRegular" className="d-flex align-items-center">
                <i className="material-icons">
                  <GroupIcon />
                </i>
                Users List
              </Box>
            </Link>
          </li>
          <li className={url === "superadmin-subscribe-users" ? "nav-item active" : "nav-item"}>
            <Link to="/superadmin-subscribe-users" className="nav-link navbar-toggler" aria-controls="navigation-index" aria-expanded="false">
              <Box fontSize={16} fontWeight="fontWeightRegular" className="d-flex align-items-center">
                <i className="material-icons">
                  <GroupIcon />
                </i>
                Subscribe Users List
              </Box>
            </Link>
          </li>
          <li className={url === "change-password" ? "nav-item active" : "nav-item"}>
            <Link to="/change-password" className="nav-link navbar-toggler" aria-controls="navigation-index" aria-expanded="false">
              <Box fontSize={16} fontWeight="fontWeightRegular" className="d-flex align-items-center">
                <i className="material-icons">
                  <LanguageIcon />
                </i>
                Change Password
              </Box>
            </Link>
          </li>
          <li className={url === "/" ? "nav-item active" : "nav-item"}>
            <Link className="nav-link navbar-toggler" aria-controls="navigation-index" aria-expanded="false" onClick={() => logout()}>
              <Box fontSize={16} fontWeight="fontWeightRegular" className="d-flex align-items-center">
                <i className="material-icons">
                  <ExitToAppIcon />
                </i>
                LOGOUT
              </Box>
            </Link>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default SuperadminSidebar;
